import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = ['target', 'trigger']
    static values = { name: String }

    connect() {
        this.toggle()
    }

    toggle() {
        const self = this

        if (this.triggerTarget.checked) {
            this.targetTarget.classList.remove(this.nameValue)

            // Reconnect selectpickers
            const selectPickers = this.targetTarget.querySelectorAll('[data-controller="selectpicker"]');
            selectPickers.forEach(picker => {
                this.application.getControllerForElementAndIdentifier(picker, 'selectpicker').connect()
            }, this)
        } else {
            this.targetTarget.classList.add(this.nameValue)
        }
    }
}
